const Style = {
    lojinhaProgressPinSpace:{
        width: 'calc(100% / 3)',
        display: 'flex',
        justifyContent: 'center',
    },
}

export default Style;